define('app/views/double_opting_confirm_view',['app/setup'], function(takhfifan) {
  takhfifan.doubleOptinConfirmView = Backbone.View.extend({
    
    events: {
      "click .close-double-optin-message" : "closeMessage"
    },
    
    initialize: function() {
      var _this = this;
      takhfifan.eventHub.on('newsletter:doubleOptinConfirm', function() {
        _this.showMessage();
      }, this);
    },
    
    closeMessage: function() {
      this.$('.double-optin-message').slideUp();
    },
        
    showMessage: function() { // Double optin confirm alert
      var message = '<div class="double-optin-message"><p><span class="icon-check"></span>ایمیل شما تایید شد. برای دریافت هدیه به ایمیلتان مراجعه کنید.</p><span class="icon-close close-double-optin-message"></span></div>';
      this.$el.prepend(message);
      this.$('.double-optin-message').slideDown();
    }
  });
});
